export default {
    'page': {
        component: import('@/views/integrations/protokol/support/Index'),
        permissions: ['view_tickets']
    },

    'home': {
        component: import('@/components/integrations/protokol/support/Home'),
        permissions: ['view_tickets']
    },

    'menu': {
        component: import('@/components/integrations/protokol/support/Menu'),
        permissions: ['view_tickets']
    }
}
